// extracted by mini-css-extract-plugin
export default {"button":"dcc_infoButton-button"};